import "./TaxiServiceDE.module.css";
import Header from "@/reusable_sections/Header";
import LocalTaxi from "./sections/LocalTaxi";
import TaxiIntro from "./sections/TaxiIntro";
import ServiceAreas from "./sections/ServiceAreas";
import TaxiUseCases from "./sections/TaxiUseCases";
import WhyChooseUs from "./sections/WhyChooseUs";
import TaxiBookingSteps from "./sections/TaxiBookingSteps";
import TaxiFaqs from "./sections/TaxiFaqs";
import LocalTaxiCta from "./sections/LocalTaxiCta";
import Footer from "@/reusable_sections/Footer";
export default function TaxiServiceDEPage() {
  return <div>
      <Header />
      <LocalTaxi />
      <TaxiIntro />
      <ServiceAreas />
      <TaxiUseCases />
      <WhyChooseUs />
      <TaxiBookingSteps />
      <TaxiFaqs />
      <LocalTaxiCta />
      <Footer />
    </div>;
}